import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { uuid } from '@core/helpers';
import { DropdownService } from 'src/app/project/components/dropdown/dropdown-service/dropdown.service';
import { TSelectOption } from 'src/app/project/components/input/select/select.model';
import { translate } from 'src/app/project/features/translate/translate';
import { TranslationPipe } from 'src/app/project/features/translate/translation.pipe';
import {
  EReminderSeriesFrequency,
  TReminderSeries,
} from 'src/app/project/modules/reminders/reminders.consts';
import { EIconPath } from 'src/app/project/shared/enums/icons.enum';

@Component({
    selector: 'pp-point-reminder-modal-frequency-picker',
    templateUrl: './point-reminder-modal-frequency-picker.component.html',
    styleUrl: './point-reminder-modal-frequency-picker.component.scss',
    standalone: false
})
export class PointReminderModalFrequencyPickerComponent {
  @Input()
  set ppDate(value: Date) {
    this.startDate = new Date(value);
  }

  /**
   * The frequency of the reminder series.
   */
  @Input() ppFrequency: EReminderSeriesFrequency;
  /**
   * The frequency of the reminder series change event for two way data binding.
   */
  @Output() ppFrequencyChange: EventEmitter<EReminderSeriesFrequency> =
    new EventEmitter<EReminderSeriesFrequency>();

  /**
   * Whether the frequency picker is disabled.
   */
  @Input() ppDisabled = false;

  selectedFrequencyIndex: number;
  EIconPath = EIconPath;
  buttonId = uuid();
  dropdown = this.dropdownService.getDropdown();
  startDate: Date;
  days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat'];
  months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  /**
   * Select component input for frequencies options
   */
  frequencies: TSelectOption[] = [
    {
      label: this.translationPipe.transform('does_not_repeat'),
      value: null,
    },
    {
      label: this.translationPipe.transform('reminders_frequency_daily'),
      value: EReminderSeriesFrequency.DAILY,
    },
    {
      label: this.translationPipe.transform('reminders_frequency_weekly'),
      value: EReminderSeriesFrequency.WEEKLY,
    },
    {
      label: this.translationPipe.transform('reminders_frequency_monthly'),
      value: EReminderSeriesFrequency.MONTHLY,
    },
    {
      label: this.translationPipe.transform('reminders_frequency_yearly'),
      value: EReminderSeriesFrequency.YEARLY,
    },
  ];
  constructor(
    private translationPipe: TranslationPipe,
    private dropdownService: DropdownService,
  ) {}

  ngAfterViewInit(): void {
    this.setFrequencySubtext();
  }

  ngOnChanges(): void {
    this.selectedFrequencyIndex = this.frequencies.findIndex(
      (frequency) => frequency.value === this.ppFrequency,
    );
    this.setFrequencySubtext();
  }

  selectItem(frequency: TSelectOption): void {
    this.ppFrequency = frequency.value as EReminderSeriesFrequency;
    this.ppFrequencyChange.emit(this.ppFrequency);
  }

  setFrequencySubtext(): void {
    this.frequencies = [
      {
        label: this.translationPipe.transform('does_not_repeat'),
        value: null,
        subtext: '',
      },
      {
        label: this.translationPipe.transform('reminders_frequency_daily'),
        value: EReminderSeriesFrequency.DAILY,
        subtext: translate('every_day'),
      },
      {
        label: this.translationPipe.transform('reminders_frequency_weekly'),
        value: EReminderSeriesFrequency.WEEKLY,
        subtext: translate('on') + ' ' + this.days[this.startDate.getDay()],
      },
      {
        label: this.translationPipe.transform('reminders_frequency_monthly'),
        value: EReminderSeriesFrequency.MONTHLY,
        subtext: translate('on') + ' ' + this.getDayWithSuffix(this.startDate),
      },
      {
        label: this.translationPipe.transform('reminders_frequency_yearly'),
        value: EReminderSeriesFrequency.YEARLY,
        subtext:
          translate('on') +
          ' ' +
          this.getDayWithSuffix(this.startDate) +
          ' ' +
          this.months[this.startDate.getMonth()],
      },
    ];
  }

  getDayWithSuffix(date: Date): string {
    const day = date.getDate();

    if (day >= 11 && day <= 13) {
      return `${day}th`;
    }

    switch (day % 10) {
      case 1:
        return `${day}st`;
      case 2:
        return `${day}nd`;
      case 3:
        return `${day}rd`;
      default:
        return `${day}th`;
    }
  }
}
